/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Sort_NewestInputs */

const en_dashboard_sort_newest = /** @type {(inputs: Dashboard_Sort_NewestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Newest`)
};

const es_dashboard_sort_newest = /** @type {(inputs: Dashboard_Sort_NewestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más recientes`)
};

/**
* | output |
* | --- |
* | "Newest" |
*
* @param {Dashboard_Sort_NewestInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dashboard_sort_newest = /** @type {((inputs?: Dashboard_Sort_NewestInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Sort_NewestInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dashboard_sort_newest(inputs)
	return en_dashboard_sort_newest(inputs)
});